import React from 'react';
import { Button } from './Button';
import { ShieldCheck, Lock } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function Offer() {
  return <section id="oferta" className="bg-navy-800 px-4 py-16 sm:px-6 lg:px-8 lg:py-24 border-t border-slate-700/50" data-id="element-139">
      <div className="mx-auto max-w-4xl text-center" data-id="element-140">
        <div className="mb-12 rounded-2xl bg-navy-900 p-8 border border-gold-500/30 shadow-2xl relative overflow-hidden" data-id="element-141">
          {/* Decorative glow */}
          <div className="absolute top-0 left-1/2 -z-10 h-[200px] w-[200px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold-500/20 blur-[80px]" data-id="element-142"></div>

          <p className="mb-6 text-lg text-slate-300 line-through decoration-red-500/50 decoration-2" data-id="element-143">
            Reparar tu crédito con un profesional te costaría entre $500 y
            $1,200 dólares en mensualidades.
          </p>

          <p className="mb-8 text-xl text-white font-medium" data-id="element-144">
            Hoy, puedes obtener el sistema completo, las estrategias de disputa
            y el plan de blindaje por una fracción de ese costo.
          </p>

          <div className="mb-8" data-id="element-145">
            <p className="text-sm font-bold text-gold-400 uppercase tracking-widest mb-2" data-id="element-146">
              Acceso Inmediato
            </p>
            <div className="flex items-center justify-center gap-2 line-through decoration-red-500 decoration-2 text-slate-500" data-id="element-147">
              <span className="text-2xl font-bold mt-2" data-id="element-148">$</span>
              <span className="text-5xl font-bebas" data-id="element-149">27</span>
              <span className="text-lg font-bold mt-3" data-id="element-150">.00 USD</span>
            </div>
            <p className="mt-3 text-lg text-gold-400 font-bold uppercase tracking-wide" data-id="element-151">
              Ahora solo por
            </p>
            <div className="flex items-center justify-center gap-2 mt-1" data-id="element-152">
              <span className="text-3xl font-bold text-green-400 mt-2" data-id="element-153">$</span>
              <span className="text-7xl font-bebas text-white" data-id="element-154">6.39</span>
              <span className="text-xl font-bold text-slate-400 mt-4" data-id="element-155">USD</span>
            </div>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-156">
            <Button className="w-full sm:w-auto text-lg px-10 py-5" onClick={() => {
            trackAddToCart();
            window.open('https://www.plenavital.com/cart/48210745295073:1', '_blank');
          }} data-id="element-157">
              ¡QUIERO MIS 700 PUNTOS AHORA!
            </Button>

            <div className="flex items-center gap-4 text-sm text-slate-400 mt-4" data-id="element-158">
              <div className="flex items-center gap-1" data-id="element-159">
                <Lock className="h-4 w-4" data-id="element-160" />
                <span data-id="element-161">Pago Seguro</span>
              </div>
              <div className="flex items-center gap-1" data-id="element-162">
                <ShieldCheck className="h-4 w-4 text-green-500" data-id="element-163" />
                <span data-id="element-164">Descarga Inmediata</span>
              </div>
            </div>
            <p className="text-xs text-slate-500 mt-2" data-id="element-165">
              Tu información está protegida mediante encriptación de 256-bits.
            </p>
          </div>
        </div>
      </div>
    </section>;
}